export default __webpack_public_path__ + "static/livebetting-1fb0d795d8ce05a8d81bc084ea1e0515.jpg";